import type {
  INeoDashboardController,
  INeoDashboardService,
} from "../../core/ports/driver/neoDashboardService";

/**
 * Neo Dashboards controller. The dashboard aggregate needs no extra
 * presentation-layer adaptation beyond what the service provides, so the
 * controller exposes the service surface directly — kept as its own factory
 * for consistency with the rest of the hexagon (page → controller → service →
 * repository).
 */
export const NeoDashboardControllerFactory = ({
  neoDashboardService,
}: {
  neoDashboardService: INeoDashboardService;
}): INeoDashboardController => {
  return {
    listDashboards: neoDashboardService.listDashboards,
    createDashboard: neoDashboardService.createDashboard,
    getDashboard: neoDashboardService.getDashboard,
    updateDashboard: neoDashboardService.updateDashboard,
    deleteDashboard: neoDashboardService.deleteDashboard,
    uploadDashboardCsv: neoDashboardService.uploadDashboardCsv,
    fetchDashboardCsvContent: neoDashboardService.fetchDashboardCsvContent,
    downloadDashboardCsvXlsx: neoDashboardService.downloadDashboardCsvXlsx,
    saveDashboardCsvEdits: neoDashboardService.saveDashboardCsvEdits,
    deleteDashboardCsv: neoDashboardService.deleteDashboardCsv,
  };
};
